var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlaneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 124,
    viewBox: "0 0 165 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.789 8.15771L93.3937 124L0 45.9921L164.789 8.15771Z",
    fill: "#4CC3B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.789 8.15771L51.1688 88.1051L27.7368 68.6493L164.789 8.15771Z",
    fill: "#90DACE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.344 70.83L113.344 70.8299C114.306 70.4174 114.895 69.532 114.895 68.5862V2.97994C114.895 1.22702 112.918 -0.0448838 111.085 0.729177L113.344 70.83ZM113.344 70.83L72.7189 88.2639L72.7186 88.264C70.8859 89.052 68.8948 87.7797 68.8948 86.0201V21.4873C68.8948 19.7601 69.9766 18.1691 71.7024 17.4343C71.7025 17.4342 71.7026 17.4342 71.7027 17.4341L111.085 0.729442L113.344 70.83Z",
    fill: "white",
    stroke: "#30426D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3948 6.5L101.395 5V78.1632L98.3948 79V6.5Z",
    fill: "#30426D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5527 69.3423L37.3183 116.658L50.3948 88.4291L27.5527 69.3423Z",
    fill: "#90DACE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.342 116.658L63.4473 98.8352L50.5843 88.1055L37.342 116.658Z",
    fill: "#3FA393"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3948 87.7085L92.9357 122L164.395 8L50.3948 87.7085Z",
    fill: "#4CC3B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneGreen);
export default __webpack_public_path__ + "static/media/paper-plane-green.9da4d167d090bde64bb74a14b5087fb5.svg";
export { ForwardRef as ReactComponent };